import styled, { css } from "styled-components";

export const StyledHamburgerButton = styled.div<{ active: boolean }>`
  display: none;
  height: var(--nav-height);
  width: var(--nav-height);
  margin-left: auto;
  cursor: pointer;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: -8px;
    grid-row: 1/2;
    grid-column: 2/3;
    margin-right: var(--nav-padding);

  }
  ${({ active }) =>
    active &&
    css`
      .line-1 {
        transform: translateY(7px) rotateZ(45deg);
      }

      .line-2 {
        transform: scaleX(0);
      }

      .line-3 {
        transform: translateY(-7px) rotateZ(-45deg);
      }
    `}
`;

export const Line = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.primary};
  width: 24px;
  height: 3px;
  border-radius: 8px;
  transition: transform 0.2s ease-in-out;

  &.line-2 {
    margin: 4px 0;
  }
`;
